import Operation from "../index.js";

export default {
    //获取加密视频解密密钥
    getPlaySafe(vid, fun) {
        Operation.Http.get(`/video/getPlaySafe/${vid}`, null, fun)
    },
}


// WEBPACK FOOTER //
// ./src/request/api/video.js